module.exports = __webpack_public_path__ + "img/example-wechat-credit-pay01.e5067b01.png";